import { Dialog, DialogContent } from '@mui/material'
import React from 'react'
import CreatEdit from './CreateEdit'
import  './vehiclemakeModal.css';

function VehiclemakeModal({productId,handleClose,riskFactorname,apiUrl,setNewValue}) {
  return (
    <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={true}
        onClose={handleClose}
      >
       
        <DialogContent className="modalContainer">
          <CreatEdit   setNewValue={setNewValue}  closeCreateEditForm={handleClose} vehichleMakeEditDatas={null} editStatus={false} />
        </DialogContent>
       
      </Dialog>
  )
}

export default VehiclemakeModal